<!--下载附件-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{
                `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
              }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>音频</p>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <!-- <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请上传文件"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->
        <MyEditor
          v-model="caseProblem"
          placeholder="请收听音频"
          @insertImg="handleCaseProblemImg"
          @input="handleInput"
        />
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
      <div class="upload-file">
        <!-- <div class="file-item" v-for="(file, index) in fileList" :key="index">
          <div class="filename">
            <img
              class="icon"
              src="https://ossfastmake.mustke.com/qrCode/tupian/1762401082820.svg"
            />
            <span>{{ file.fileName || `文件${index + 1}` }}</span>
          </div>
          <img
            class="del"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1761120250640.svg"
            @click="deleteFile(index)"
          />
        </div> -->

        <!-- <div
          v-for="(audioItem, audioIndex) in fileList"
          :key="audioIndex"
          class="music-view"
          @click="handleAudioPlay(index, audioIndex)"
        >
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/music-1769330643047.png"
            class="music-image"
            alt="音频"
          />
          <div class="music-time">{{ secondsToHms(audioItem.time) }}</div>
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
            class="del"
            @click.stop="handleDeleteChildAudio(index)"
            alt="删除"
          />
        </div> -->

        <div
          v-for="(audioItem, audioIndex) in fileList"
          :key="audioIndex"
          class="music-view"
          @click="handleAudioPlay(index, audioIndex)"
        >
          <AudioItem
            :styleType="'2'"
            :key="audioIndex"
            :title="audioItem.name"
            :src="audioItem.url"
            :playing-id="playingId"
            :time="audioItem.time"
            :param="[index, null]"
            @delete-audio="handleDeleteChildAudio"
            @play="onPlay"
          />
        </div>

        <div class="button" @click="chooseFile">
          <img
            class="icon"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1761100444730.svg"
          />
          选择音频
        </div>
        <div class="text">支持MP3格式上传(最大5MB)</div>
      </div>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
    <input
      ref="uploadInput"
      type="file"
      multiple
      accept="audio/mp3"
      style="display: none"
      @change="handleFileSelect"
    />
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
import AudioItem from "@/components/AudioItem/index.vue";

export default {
  components: {
    PopupInput,
    AudioItem,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [], // 选项列表
      dataObj: {}, // 存储当前问题的数据
      showpopup: false, // 批量添加选项的弹框
      uploadIndex: 0,
      images: [], // 题目图片列表
      caseProblem: "", // 题目说明
      fileList: [],
      // audioContext: null, // 音频上下文
      // currentAudio: null, // 用于追踪当前播放的音频
      playingId: "", // 用于追踪当前播放的音频索引
    };
  },
  mounted() {
    // this.audioContext = new Audio();
  },
  // beforeDestroy() {
  //   // 销毁音频上下文
  //   if (this.audioContext) {
  //     this.audioContext.pause();
  //     this.audioContext = null;
  //   }
  //   this.playingId = "";
  // },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.caseProblemImg = JSON.stringify(this.images);

      //   const listData = this.fileList.map((f) => ({
      //     id: "",
      //     text: f.url,
      //     fileName: f.fileName || "",
      //   }));
      this.dataObj.chooseList = JSON.stringify({
        list: this.fileList,
      });

      this.dataObj.pictureNum = this.pictureNum;

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    saveClick() {
      this.dataObj.caseProblemImg = JSON.stringify(this.images);

      //   const listData = this.fileList.map((f) => ({
      //     id: "",
      //     text: f.url,
      //     fileName: f.fileName || "",
      //   }));
      this.dataObj.chooseList = JSON.stringify({
        list: this.fileList,
      });

      this.dataObj.caseProblem = this.caseProblem || "请输入题目说明";
      this.dataObj.pictureNum = this.pictureNum;

      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleClick() {},
    chooseFile() {
      if (this.fileList.length >= 2) {
        this.$message.warning("最多只能上传2个文件");
        return;
      }
      this.$refs.uploadInput.click();
    },

    handleFileSelect(e) {
      let files = Array.from(e.target.files);

      const file = files[0];
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning("音频大小不能超过5MB");
        return;
      }

      // 先获取音频时长
      const audio = new Audio(URL.createObjectURL(file));
      audio.onloadedmetadata = () => {
        const duration = Math.ceil(audio.duration);
        // 上传文件
        const formData = new FormData();
        formData.append("file", file);
        formData.append("uuid", localStorage.getItem("uuid") || "");
        axios
          .post(baseURL + "/PCwj/file/uploads", formData, {
            headers: {
              "Content-Type": "multipart/form-data", // 必须设置
              token: localStorage.getItem("token"),
            },
          })
          .then((res) => {
            console.log(
              "response.data.urls",
              res.data.code,
              res.data.code === 200,
            );

            if (res.data.code === 200) {
              // console.log("files[0].name", files[0].name);
              this.fileList.push({
                url: res.data.urls,
                name: res.data.fileNames,
                time: Math.ceil(parseInt(duration)),
                showTime: Math.ceil(parseInt(duration)),
              });

              console.log("[][][][][][][][]=====", this.fileList);

              this.$message.success("上传成功");
            } else {
              this.$message.error(res.data.msg || "上传失败");
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      };

      e.target.value = "";
    },

    deleteFile(index) {
      this.$confirm("文件删除后不可恢复，确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.fileList.splice(index, 1);
          this.handleUpdateQuestion();
        })
        .catch(() => {});
    },

    // // 音频播放/暂停
    // handleAudioPlay(index, audioIndex) {
    //   const audioUrl = this.fileList[index].url;

    //   // 检查是否是当前正在播放的音频
    //   if (
    //     this.currentAudio &&
    //     this.currentAudio.index === index &&
    //     !this.audioContext.paused
    //   ) {
    //     // 暂停当前音频
    //     this.audioContext.pause();
    //     this.currentAudio = null;
    //   } else {
    //     // 停止当前音频（如果有）
    //     if (!this.audioContext.paused) {
    //       this.audioContext.pause();
    //     }
    //     // 播放新音频
    //     this.audioContext.src = audioUrl;
    //     this.audioContext.play();
    //     // 记录当前播放的音频信息
    //     this.currentAudio = {
    //       index: index,
    //       audioIndex: audioIndex,
    //       url: audioUrl,
    //     };
    //   }
    // },
    // // 秒转时分秒
    // secondsToHms(seconds) {
    //   const hours = Math.floor(seconds / 3600);
    //   const minutes = Math.floor((seconds % 3600) / 60);
    //   const secs = seconds % 60;
    //   return [hours, minutes, secs]
    //     .map((v) => (v < 10 ? `0${v}` : v))
    //     .join(":");
    // },
    // 删除音频
    handleDeleteChildAudio(index) {
      // // 判断如果是当前播放的音频，直接停止播放
      // if (this.currentAudio && this.currentAudio.index === index) {
      //   if (!this.audioContext.paused) {
      //     this.audioContext.pause();
      //   }
      //   this.currentAudio = null;
      // }
      this.fileList.splice(index, 1);
    },
    onPlay(id) {
      this.playingId = id;
    },
  },
  watch: {
    params: {
      handler(newVal) {
        if (!newVal) return;

        const data = newVal.data || newVal;
        this.dataObj = data;

        this.caseProblem = data.caseProblem || "";
        this.pictureNum = data.pictureNum || 1;

        try {
          this.images = JSON.parse(data.caseProblemImg || "[]");
        } catch (e) {
          this.images = [];
        }

        try {
          const chooseList = JSON.parse(
            this.dataObj.chooseList || '{"list": []}',
          );
          this.fileList = chooseList.list || [];
        } catch (e) {
          this.fileList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}

.textarea-box textarea {
  color: #4c4a56;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}

.select-box {
  display: flex;
  align-items: center;
}

.select-box p {
  margin-right: 5px;
  white-space: nowrap;
}

.upload-file {
  margin: 10px 0;
}

.upload-file .button {
  background: #3a60ff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 14px;
  color: #fff;
  font-weight: Semibold;
  margin-top: 10px;
  height: 39px;
  cursor: pointer;
}

.upload-file .button .icon {
  width: 17px;
  height: 17px;
}

.upload-file .text {
  font-size: 12px;
  color: #2b2f36;
  margin: 10px 0;
  text-align: center;
}

.upload-file .file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file .file-item .filename {
  max-width: 90%;
  display: flex;
  align-items: center;
  gap: 8.5px;
}

.upload-file .file-item .filename .icon {
  width: 24px;
  height: 21px;
  flex: none;
}
.upload-file .file-item .filename span {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #333;
}
.upload-file .file-item .del {
  width: 16px;
  height: 16px;
}

.upload-file .file-item + .file-item {
  margin-top: 5px;
}

.music-view {
  width: 100%;
  height: 38.5px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 19.25px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  position: relative;
  cursor: pointer;
}

.music-image {
  width: 16px;
  height: 20px;
  margin-left: 10.5px;
}

.music-time {
  font-size: 15px;
  font-weight: 600;
  color: #656374;
  margin-left: 14.5px;
}

.del {
  position: absolute;
  top: -7.5px;
  right: -7.5px;
  width: 20px;
  height: 20px;
  z-index: 10;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationEdit/EvaluationEditAudio.vue